const list = [
//   {
//   id: 1,
//   name: '青岛农业大学',
//   type: '无线网络',
//   detailType: '高校',
//   imageSrc: 'image/partner/case1.png',
//   desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩…',
//   tags: ['重大项目', '柠檬力推', '助力68%增值']
// },
//   {
//     id: 2,
//     name: '浙江理工大学',
//     type: '无线网络',
//     detailType: '中职',
//     imageSrc: 'image/partner/case2.png',
//     desc: '简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属…',
//     tags: ['重大项目', '柠檬力推', '助力98%增值']
//   },
//   {
//     id: 3,
//     name: '河南理工大学鹤壁工程技术学院',
//     type: '无线网络',
//     detailType: '工厂',
//     imageSrc: 'image/partner/case3.png',
//     desc: '2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 4,
//     name: '青岛农业大学111',
//     type: '无线网络',
//     detailType: '高校',
//     imageSrc: 'image/partner/case2.png',
//     desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 5,
//     name: '浙江理工大学111',
//     type: '无线网络',
//     detailType: '中职',
//     imageSrc: 'image/partner/case2.png',
//     desc: '简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 6,
//     name: '河南理工大学鹤壁工程技术学院111',
//     type: '无线网络',
//     detailType: '工厂',
//     imageSrc: 'image/partner/case3.png',
//     desc: '2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 7,
//     name: '青岛农业大学222',
//     type: '无线网络',
//     detailType: '高校',
//     imageSrc: 'image/partner/case3.png',
//     desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 8,
//     name: '浙江理工大学222',
//     type: '无线网络',
//     detailType: '中职',
//     imageSrc: 'image/partner/case2.png',
//     desc: '简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 9,
//     name: '河南理工大学鹤壁工程技术学院222',
//     type: '无线网络',
//     detailType: '工厂',
//     imageSrc: 'image/partner/case3.png',
//     desc: '2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 10,
//     name: '青岛农业大学333',
//     type: '无线网络',
//     detailType: '高校',
//     imageSrc: 'image/partner/case1.png',
//     desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 11,
//     name: '浙江理工大学333',
//     type: '无线网络',
//     detailType: '中职',
//     imageSrc: 'image/partner/case2.png',
//     desc: '简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 12,
//     name: '河南理工大学鹤壁工程技术学院333',
//     type: '无线网络',
//     detailType: '工厂',
//     imageSrc: 'image/partner/case3.png',
//     desc: '2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 13,
//     name: '青岛农业大学',
//     type: '智慧校园',
//     detailType: '高校',
//     imageSrc: 'image/partner/case1.png',
//     desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 14,
//     name: '浙江理工大学',
//     type: '智慧校园',
//     detailType: '中职',
//     imageSrc: 'image/partner/case2.png',
//     desc: '简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 15,
//     name: '河南理工大学鹤壁工程技术学院',
//     type: '智慧校园',
//     detailType: '工厂',
//     imageSrc: 'image/partner/case3.png',
//     desc: '2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 16,
//     name: '青岛农业大学111',
//     type: '智慧校园',
//     detailType: '高校',
//     imageSrc: 'image/partner/case1.png',
//     desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 17,
//     name: '浙江理工大学111',
//     type: '智慧校园',
//     detailType: '中职',
//     imageSrc: 'image/partner/case2.png',
//     desc: '简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 18,
//     name: '河南理工大学鹤壁工程技术学院111',
//     type: '智慧校园',
//     detailType: '工厂',
//     imageSrc: 'image/partner/case3.png',
//     desc: '2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 19,
//     name: '青岛农业大学222',
//     type: '智慧校园',
//     detailType: '高校',
//     imageSrc: 'image/partner/case1.png',
//     desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 20,
//     name: '浙江理工大学222',
//     type: '智慧校园',
//     detailType: '中职',
//     imageSrc: 'image/partner/case2.png',
//     desc: '简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 21,
//     name: '河南理工大学鹤壁工程技术学院222',
//     type: '智慧校园',
//     detailType: '工厂',
//     imageSrc: 'image/partner/case3.png',
//     desc: '2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 22,
//     name: '青岛农业大学333',
//     type: '智慧校园',
//     detailType: '高校',
//     imageSrc: 'image/partner/case1.png',
//     desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 23,
//     name: '浙江理工大学333',
//     type: '智慧校园',
//     detailType: '中职',
//     imageSrc: 'image/partner/case2.png',
//     desc: '简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
//   {
//     id: 24,
//     name: '河南理工大学鹤壁工程技术学院333',
//     type: '智慧校园',
//     detailType: '工厂',
//     imageSrc: 'image/partner/case3.png',
//     desc: '2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇…',
//     tags: ['重大项目', '柠檬力推', '助力68%增值']
//   },
  {
    id: 25,
    name: '河南信息科技学院',
    type: '无线网络',
    detailType: '高校',
    imageSrc: 'image/partner/case3.png',
    desc: '河南理工大学鹤壁工程技术学院（Hebi School of Engineering and Technology, Henan University of Technology）是2015年经河南省教育厅批准设立的河南理工大学二级学院，由河南理工大学与鹤壁市政府共同管理，办学地点在鹤壁市淇滨区淇水关路东段（大学路一号）。',
    tags: ['高速稳定接入', '全光网络部署', '创新技术应用']
  },
  {
    id: 26,
    name: '青岛农业大学',
    type: '无线网络',
    detailType: '高校',
    imageSrc: 'image/partner/case1.png',
    desc: '青岛农业大学始建于1951年，建有城阳、平度、莱阳、蓝谷四个校区和现代农业科技服务中心。学校总占地面积5220亩，校舍建筑总面积110余万平方米。设有25个教学院部，开设82个本科专业，拥有2个博士学位授权一级学科、14个硕士学位授权一级学科、13个专业学位硕士授权类别，有全日制在校生3万余人。网联覆盖区域为西苑校区，住宿约为10000人。',
    tags: ['高速稳定接入', '安全可靠性', '创新技术应用']
  },
  {
    id: 27,
    name: '浙江理工大学',
    type: '无线网络',
    detailType: '高校',
    imageSrc: 'image/partner/case2.png',
    desc: '浙江理工大学（Zhejiang Sci-Tech University），简称“浙理工”，坐落于浙江省杭州市，是一所以工为主，理、工、文、经、管、法、艺术、教育等多学科协调发展的省属重点建设大学，是长三角高水平行业特色大学联盟成员，入选教育部“卓越工程师教育培养计划“、中国政府奖学金来华留学生接收院校、全国高校实践育人创新创业基地、国家国际科技合作基地、国家级大学生创新创业训练计划、国家级新工科研究与实践项目、浙江省院士专家工作站，具有推荐优秀应届本科毕业生免试攻读硕士学位研究生资格。',
    tags: ['用户体验优先', '兼容性与扩展性', '节能环保设计']
  },
  {
    id: 28,
    name: '比亚迪',
    type: '无线网络',
    detailType: '工厂',
    imageSrc: 'image/partner/case-byd.png',
    desc: '比亚迪唯一官方WiFi合作伙伴，全面覆盖广东深圳、广西桂林、上海、北京、安徽芜湖、湖南长沙、湖北武汉、浙江宁波、重庆、江苏南京、辽宁大连、山东青岛、内蒙包头、宁夏银川、青海西宁等四十多个工业园区超百万用户。\n',
    tags: ['高速稳定接入', '安全可靠性', '智能运维管理']
  },
  {
    id: 29,
    name: '富士康',
    type: '无线网络',
    detailType: '工厂',
    imageSrc: 'image/partner/case-fsk.png',
    desc: '富士康唯一官方WiFi合作伙伴，全面覆盖广东深圳、河南郑州、河南济源、河南中牟、山西太原、山西晋城、贵州贵安、浙江嘉善、江苏昆山、江苏淮安、湖北武汉等二十多个厂区近百万用户，并提供自助洗衣等多类生活服务',
    tags: ['高密度接入能力', '安全可靠性', '用户体验优先']
  },
  {
    id: 30,
    name: '和硕集团',
    type: '无线网络',
    detailType: '工厂',
    imageSrc: 'image/partner/case-hs.jpg',
    desc: '和硕集团旗下昌硕、世硕唯一官方WiFi合作伙伴，全面覆盖上海、昆山等各大工厂，为近十万员工提供上网服务。',
    tags: ['无线覆盖方案', '安全可靠性', '集中式管理']
  },
  {
    id: 31,
    name: '凯利公社',
    type: '无线网络',
    detailType: '工厂',
    imageSrc: 'image/partner/case-klgs.jpg',
    desc: '凯利公社是无锡市首家采取“集中居住，集中管理”的企业员工大型宿舍区，入驻数十家企业员工几万人，网联实现独家全面覆盖。',
    tags: ['用户体验优先', '安全可靠性', 'AI智能运维']
  },
  {
    id: 32,
    name: '立讯精密',
    type: '无线网络',
    detailType: '工厂',
    imageSrc: 'image/partner/case-lx.png',
    desc: '立讯精密唯一官方WiFi合作伙伴，全面覆盖东莞、吉安、昆山、巴城、盐城、嘉善、常州、亳州、滁州、梅州等立讯及子公司各大厂区宿舍，为立讯 员工提供WiFi上网、自助娱乐、自助健身等多方面智慧宿舍生活服务。',
    tags: ['用户体验优先', 'AI智能运维', '快速漫游切换']
  },
  {
    id: 33,
    name: '仁宝电脑',
    type: '无线网络',
    detailType: '工厂',
    imageSrc: 'image/partner/case-rb.jpg',
    desc: '仁宝电脑是全球排名前两位的笔记本电脑制造商，昆山是仁宝的制造中心，网联已全面独家覆盖仁宝昆山所有厂区。',
    tags: ['高速稳定接入', '安全可靠性', '创新技术应用']
  },
  {
    id: 34,
    name: '安徽淮南技工学校',
    type: '无线网络',
    detailType: '中职',
    imageSrc: 'image/partner/case4.png',
    desc: '安徽省淮南技工学校是1979年5月经省政府批准成立的，2000年8月经原国家劳动和社会保障部批准组建为“安徽省工业高级技工学校”，是政府部门主办的一所高级技校。是省“机电高技能人才培训基地”，我市的“公共就业实训基地”、“农民工培训示范基地”，设有“国家职业技能鉴定站”。',
    tags: ['高速稳定接入', '安全可靠性', '用户体验优先']
  },
  {
    id: 34,
    name: '福建诚毅技术学校',
    type: '无线网络',
    detailType: '中职',
    imageSrc: 'image/partner/case9.jpg',
    desc: '福建省诚毅技术学校是经福建省人力资源和社会保障厅批准成立（批准文号闽劳社文【2004】295），学校代码(064)，直属省人力资源和社会保障厅，以培养高等职业技术人才为主的专业学校。',
    tags: ['高速稳定接入', '安全可靠性', '用户体验优先']
  },
  {
    id: 35,
    name: '广东北达技工学校',
    type: '无线网络',
    detailType: '中职',
    imageSrc: 'image/partner/case5.png',
    desc: '广州市北达技工学校 [1]是经广州市人力资源和社会保障局于2007年批准成立的一所全日制技工院校。是全省加出入校园人脸识别系统的学校，安全系数最高，学生军事化管理！学校由北京大学校友会创办，继承北大百年老校严谨教学作风：“勤奋，求实，创新”。我校地铁4号线直达，报读的学生可享受国家万元学费补贴，全日制学历（5年本科），100%空调新宿舍，99%高薪就业，企业订单培养：美的电器校企人才培养基地，京东商城校企合作单位，腾讯广州运营中心校企合作单位，广汽集团校企合作优秀院校，华南理工大学公开学院指定合作院校……被广大师生评为广州最南边的最好的技工学校。我校占地面积100亩，在校生近2300人。现面向全国招收初三应届和往届优秀毕业学生。',
    tags: ['高速稳定接入', '快速漫游切换', '高密度接入能力']
  },
  {
    id: 36,
    name: '广西工业技师学院',
    type: '无线网络',
    detailType: '中职',
    imageSrc: 'image/partner/case6.png',
    desc: '广西工业技师学院，又名广西石化高级技工学校，隶属广西壮族自治区工业和信息化厅，是首府南宁和北部湾经济区规模最大、特色鲜明的国家级重点技工院校，被评为“国家中等职业教育改革发展示范学校”、“全国职业教育先进单位”、“全国文明单位”、“国家高技能人才培养示范基地”、“国家级高技能人才培训基地”、“全国技工院校师资培训基地”、“全国中等职业学校德育工作先进集体”、“石油和化工行业职业教育与培训全国示范性实训基地”、 “中国企业教育先进单位百强”、“自治区示范性中等职业学校”、“自治区示范性中等职业教育实训基地”。',
    tags: ['高速稳定接入', '安全可靠性', '教学科研支持']
  },
  {
    id: 37,
    name: '江西丰城技工学校',
    type: '无线网络',
    detailType: '中职',
    imageSrc: 'image/partner/case7.png',
    desc:'丰城市职业中学创办于1986年。学校位于江西省丰城市丰源工业园芝山路22号，是一所集学历教育和技能培训为一体的综合性省级重点中等专业学校。',
    tags: ['高速稳定接入', '安全可靠性', '创新技术应用']
  },
  {
    id: 38,
    name: '陕西航空医科职业技术学校',
    type: '无线网络',
    detailType: '中职',
    imageSrc: 'image/partner/case8.png',
    desc:'陕西航空医科学校是由陕西省教育厅批准成立，国家教育部备案的全日制院校。学校下设医学类、航空轨道交通类、教育机关类、金融类等20余个紧缺型热门专业。学校成立于1998年，建校已有20多年的历史，期间被政府评为“陕西省示范学校”，“西安市重点学校”，“医学卫生类指定招生学校”，“陕西省校企合作示范院校”和“双师型师资教育教学示范院校”，被社会评为“安置就业的一面旗帜”，是中高等卫生技术人才培养基地，航空服务、高铁乘务、轨道交通类西北地区培养基地。',
    tags: ['高速稳定接入', '节能环保设计', '安全性强化']
  },


]

export default list



// WEBPACK FOOTER //
// ./src/pages/partner/casesData.js